import {startOfDay} from "./startOfDay";

export function addDays(d, days) {
    const date = new Date(d);
    date.setDate(date.getDate()+days);
    return startOfDay(date);
}